import http from "./http";

//获取用户
export function getAllUser(str, offset, limit) {
  return new Promise((resolve, reject) => {
    http
      .get("/account/v2?str=" + str + "&offset=" + offset + "&limit=" + limit)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

//创建用户
export function add_user_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/account", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改用户
export function edit_user_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/account", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//封禁用户
export function ban_user_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/account/availability", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改用户权限
export function edit_user_permission_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/account/permission", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//用户修改密码
export function edit_user_password_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/account/profile", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//查看权限
export function post_permission_api(id, data) {
  return new Promise((resolve, reject) => {
    http.post("/account/permission?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
